import { isArray } from './utils';
import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType, SupportedRegExType } from './dr-object';
import { Role } from './role';

export class UserViewModel extends DrObject {

    model: Partial<User>;
    original: Partial<User>;

    constructor(value?: Partial<User>) {
        super(DrObjectType.USER, SupportedRegExType.USER_GROUP);
        if (value) {
            this.model = this.original = value;
        }
    }
}

export enum TpAuthStatus {
    Success = 'Success',
    Failure = 'Failure',
    Partial = 'Partial',
    NotApplicable = 'N/A'
}

export class User extends DrEntity {
    organizationHandle: string;
    domainHandle: string;
    groupHandle: string;
    userName: string;
    firstName: string;
    lastName: string;
    distinguishedName: string;
    email: string;
    description: string;
    admin: boolean;
    enabled: boolean;
    local: boolean;
    roleHandles: Array<string>;
    projects: Array<any>;
    daysUntilPasswordExpires: number;
    customerName: string;
    importedFromSystemUser: boolean;
    roles: Array<Role>;
    systemRoles: Array<Role>;
    mfa: boolean;
    conditionalOnIPAddress: boolean;
    allowedIPAddressRange: Array<string>;
    authenticationMethod: string;
    locked: boolean;
    tpAuthUserStatus: TpAuthStatus;
    ediscoveryEula: boolean;

    name: string;
    originalCustomerName: string;
    userRole: string;
    loginUsername: string;
    type: string;
    iconClass: string;
    userStatus: string;
    deviceId: string;
    isSuperSystemUser?: boolean;
    isTpAuth: boolean;
    tpAuthStatusIconClass: string;
    tpAuthStatusIconColor: string;
    tpAuthUIUserStatus?: string;

    constructor(value?: Partial<User>) {
        super(value);
        if (value) {
            if (isArray(value.roles) && value.roles.length > 0) {
                value.roles = value.roles.map(role => new Role(role));
                value.userRole = value.roles[value.roles.length - 1].name;
            }
            value.name = value.userName;
            value.type = value.importedFromSystemUser || value.customerName === 'super_system_customer' ? 'System User' : 'User';
            value.iconClass = `fa-user ${value.importedFromSystemUser || value.customerName === 'super_system_customer' ? ' color-purple-03' : ' color-yellow-07'}`;
            value.userStatus = value.locked ? 'locked' : 'unlocked';
            value.isTpAuth = value.authenticationMethod === 'TP_AUTH_ONLY' || value.authenticationMethod === 'TP_AUTH_WITH_IP';
            value.tpAuthUserStatus = value.tpAuthUserStatus ?? TpAuthStatus.NotApplicable;
            value.tpAuthUIUserStatus = value.tpAuthUserStatus === TpAuthStatus.Partial ? TpAuthStatus.Failure : value.tpAuthUserStatus;
            if (value.isTpAuth) {
                switch (value.tpAuthUIUserStatus) {
                    case TpAuthStatus.Success:
                        value.tpAuthStatusIconClass = 'fa-check';
                        value.tpAuthStatusIconColor = 'color-green-04';
                        break;
                    case TpAuthStatus.Failure:
                        value.tpAuthStatusIconClass = 'fa-exclamation-circle';
                        value.tpAuthStatusIconColor = 'color-red-05';
                        break;
                }
            } else {
                value.tpAuthUIUserStatus = TpAuthStatus.NotApplicable;
            }
            Object.assign(this, value);
        }
    }
}
